module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p1s4titles":[{"titleS":false,"title":"Listen to the "},{"titleS":true,"title":"opinions "},{"titleS":false,"title":"of other students about AICAD Business School"}]},"es":{"p1s4titles":[{"titleS":false,"title":"Escucha las "},{"titleS":true,"title":"opiniones "},{"titleS":false,"title":"de otros alumnos sobre AICAD Business School"}]}}')
  delete Component.options._Ctor
}
